import gql from "graphql-tag";
import LocalBookFragments from "@/graphql/LocalBookFragments";

export default {
  createFeaturedBook: gql`
    mutation createFeaturedBook($input: createFeaturedBookInput!) {
      createFeaturedBook(input: $input) {
        featuredBook {
          id
          _id
          position
          region
          book {
            ...LocalBookCore
          }
        }
      }
    }
    ${LocalBookFragments.localBookCoreFragment}
  `,

  deleteFeaturedBook: gql`
    mutation deleteFeaturedBook($id: ID!) {
      deleteFeaturedBook(input: { id: $id }) {
        featuredBook {
          id
        }
      }
    }
  `,

  reorderFeaturedBooks: gql`
    mutation reorderFeaturedBooks($input: reorderFeaturedBookInput!) {
      reorderFeaturedBook(input: $input) {
        featuredBook {
          id
          _id
          position
        }
      }
    }
    `,
};
